import { Component } from '@angular/core';
import { PopoverRef } from 'src/@vex/components/popover/popover-ref';
import { CandidateService } from 'src/app/services/candidate-service.service';
import { ExamService } from 'src/app/services/exam-service.service';
import { SnackbarService } from 'src/app/services/snackbar.service';

@Component({
  selector: 'app-import-passwords',
  templateUrl: './import-passwords.component.html',
  styleUrls: ['./import-passwords.component.scss']
})
export class ImportPasswordsComponent {
  file: File = null;
  constructor(private snackBar: SnackbarService, private candidateServices: CandidateService, private popoverRef: PopoverRef<ImportPasswordsComponent>,) { }

  ngOnInit() {
  }
  onFileChange(event: any) {
    if (event.target.files && event.target.files[0]) {
      this.file = event.target.files[0];
    }
  }
  close() {
    this.popoverRef.close();
  }
  async importPassword() {
    let formData = new FormData();
    formData.append('file', this.file);
    try {
      if (!this.file) {
        this.snackBar.error("\n*No file selected\n");
        return;
      }
      let formData = new FormData();
      formData.append('file', this.file);

      await this.candidateServices.importPasswordFromExcel(formData).then(s => {
        this.snackBar.success('Import Successfull');
        this.close();
      });
    } catch (error) {
      console.log(error);
      this.snackBar.error(error);
    }

  }
}
